/* eslint-disable prettier/prettier */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Button as MuiButton } from "@mui/material";
import { Helmet } from "react-helmet";
import useMediaQuery from "@mui/material/useMediaQuery";
import ReloadIcon from "../../../assets/svg/ReloadIcon";
import AppliedFilter from "../../../components/common/AppliedFilter/AppliedFilter";
import Loader from "../../../components/common/Loader/Loader";
import Modal from "../../../components/common/Modal/Modal";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import Toast from "../../../components/common/Toast";
import useUserConfig from "../../../hooks/useUserConfig";
import {
  AppliedFilterLabelMap,
  DATES,
  EVENT_NAME,
  Constants,
  AlertStatus,
} from "../../../contants";
import useQueryParams from "../../../hooks/useQueryParams";
import {
  INITIATE_APPOINTMENT_APPLICATIONS_TRACKING,
  SET_SELECTED_MEMBER_TRANSFER,
  SET_MEMBER_FOR_APPLY_APPOINTMENT,
} from "../../../redux/actionTypes/dashboard";
import {
  selectAllSIUsers,
  selectOSKeysByUserRole,
} from "../../../redux/selectors/user";
import { ROUTES } from "../../../utils/constants";
import { formDataToObject, isEmptyObj } from "../../../utils/helper";
import OrganizationSearchWrapper from "../../member/MemberSearch/OrganizationSearch";
import {
  getFilters,
  getFormattedQuery,
  handleDependencyFilter,
  performOperation,
} from "./Utils";
import Styles from "../../member/MemberSearch/MemberSearch.styles";
import PersonalDetailsSearch from "./PersonalDetailsSearch";
import Appointment from "../../../services/api/appointment";
import AppointmentTrackingTable from "./Table";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";

const LOADER_DELAY = 1000;
const PAGE = "page";
const filterOrder = [
  "areaId",
  "clusterId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
];

function AppointmentTrackingList() {
  const TITLE = "Appointment Tracking - BSG";
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openResultModal, setOpenResultModal] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const metaData = useSelector((state) => state.newMeta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const {
    isHelpDesk,
    isChapterSi,
    isHelpDeskAdmin,
    isAreaSi,
    isClusterSi,
    isZoneSi,
  } = useSelector(selectAllSIUsers);
  const hasPermission = useUserConfig();
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();
  const toast = useContext(ToastAlertContext);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMap).forEach((key) => {
      if (formRef?.current?.[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };

  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    setCurrentPage(0);
    setTotalPages(0);
    setTotalElements(0);
    setPageSize(Constants.DEFAULT_PAGE_SIZE);
    clearFormRef();
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current?.[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const getRoutePath = () => ROUTES.APPOINTMENT_TRACKING.path;

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRoutePath()}?${query}`);
    } else {
      navigate(`${getRoutePath()}`);
    }
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = {
      ...queryObject,
      number: 0,
      size: Constants.DEFAULT_PAGE_SIZE,
    };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];

      // ✅ add this for your new keys
      if (filterKey === "from") delete updatedQuery.to;
      else if (filterKey === "to") delete updatedQuery.from;
      else delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);

    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
  };

  const fetchSearchData = async (queryParams) => {
    const formattedQuery = getFormattedQuery({
      ...queryParams,
      page: queryParams.number,
      size: queryParams.size,
    });

    dispatch({
      type: INITIATE_APPOINTMENT_APPLICATIONS_TRACKING,
      payload: formattedQuery,
    });

    try {
      setIsLoading(true);

      const { data } = await Appointment.appointmentTracking(formattedQuery);

      setTimeout(() => {
        setSearchData(data.content);
        setCurrentPage(data.number);
        setTotalPages(data.totalPages);
        setTotalElements(data.totalElements);
        setPageSize(data.size);
        setIsLoading(false);

        // ✅ Modal open karo agar data hai
        if (data.content?.length > 0) {
          setOpenResultModal(true);
        } else {
          setShowToast({
            severity: "error",
            message: "No data found",
          });
          setOpenResultModal(false);
        }
      }, LOADER_DELAY);
    } catch (error) {
      setIsLoading(false);
      setShowToast({
        severity: "error",
        message:
          error.message || "Something went wrong. Please contact support.",
      });
      Sentry.captureException(error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);

    const hasFilter = Object.values(formData).some(
      (val) => val && String(val).trim() !== ""
    );
    if (!hasFilter) {
      setShowToast({
        severity: "warning",
        message: "Please select your search filter",
      });
      return;
    }

    formData.number = 0;
    formData.size = Constants.DEFAULT_PAGE_SIZE;
    const query = queryString.stringify(formData);

    document.dispatchEvent(new Event(EVENT_NAME));

    updateSearchParam(query);
  };

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const [query, params] = getQueryParams(queryObject);
      fetchSearchData(query, params);
      initializeFormState(query);
    } else {
      resetFormState();
      setOpenResultModal(false);
    }
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      const queryWithoutPagination = { ...query };
      delete queryWithoutPagination.number;
      delete queryWithoutPagination.size;
      setAppliedFilters(
        getFilters(queryWithoutPagination, metaData, disabledOSKeys)
      );
    }
  }, [metaData, urlSearchParams.toString()]);
  // useEffect(() => {
  //   fetchSearchData({ number: currentPage, size: pageSize });
  // }, []);

  const onPaginationClick = (clickedNumber) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      number: clickedNumber,
    });
    updateSearchParam(queryParams);
  };

  const onPageSizeClick = (operator) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      number: 0,
      size: queryObject.size
        ? performOperation(
            queryObject.size,
            Constants.DEFAULT_PAGE_SIZE,
            operator
          )
        : 2 * Constants.DEFAULT_PAGE_SIZE,
    });
    updateSearchParam(queryParams);
  };

  const onSelectMemberForTransfer = (member) => {
    dispatch({
      type: SET_SELECTED_MEMBER_TRANSFER,
      payload: member,
    });
    navigate(ROUTES.MEMBER_TRANSFER_REQUEST.path);
  };

  const onMemberSelect = (selectedMember, params = "") => {
    dispatch({
      type: SET_MEMBER_FOR_APPLY_APPOINTMENT,
      payload: selectedMember,
    });

    sessionStorage.setItem(
      "selectedAppointmentMember",
      JSON.stringify(selectedMember)
    );

    navigate(
      `${ROUTES.APPOINTMENT_SUBMISSION.path}${params ? `/${params}` : ""}`
    );
  };

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params);
  };

  const handleGoBackToSearch = () => {
    setOpenResultModal(false);
  };

  const handleResetAndClose = () => {
    resetFormState();
    updateSearchParam();
    setOpenResultModal(false);
  };

  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <style jsx>{`
        /* Top space fix */
        .css-m4ph9e {
          margin-top: 0 !important;
          margin-bottom: 0 !important;
        }
        /* Bottom space fix */
        .MuiBox-root[style*="min-height: 400px"] {
          min-height: 0 !important;
          height: auto !important;
        }
      `}</style>
      <div style={Styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1px",
          }}
        >
          <MuiButton
            onClick={handleResetAndClose}
            variant="outlined"
            color="secondary"
            sx={{
              textTransform: "none",
              height: "20px",
              fontSize: "13px",
              fontWeight: "600",
              marginRight: "10px",
              width: "85px",
              padding: "0px !important",
            }}
          >
            Clear Filters
          </MuiButton>
        </div>

        {/* Search Form */}
        <div style={Styles.filter}>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              width: "100%",
            }}
            onSubmit={onSubmit}
            ref={formRef}
          >
            {/* Organization Structure */}
            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Organization Structure
              </div>
              <OrganizationSearchWrapper
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>

            {/* Personal Details */}
            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Personal Details
              </div>
              <PersonalDetailsSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>

            {/* Search Button */}
            <div
              style={{
                display: "flex",
                justifyContent: isMobile ? "center" : "flex-end",
                paddingTop: isMobile ? "20px" : "10px",
                marginRight: isMobile ? "15px" : "10px",
                paddingBottom: isMobile ? "100px" : "0px",
              }}
            >
              <MuiButton
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  width: isMobile ? "90%" : "auto",
                }}
              >
                Search
              </MuiButton>
            </div>
          </form>
        </div>
        {/* Mobile separator border - visual boundary */}
        {isMobile && (
          <div
            style={{
              borderTop: "2px solid #ffffffff",
              paddingTop: "15px",
              paddingBottom: "30px",
              marginTop: "10px",
            }}
          />
        )}

        {isLoading && <Loader />}

        {/* Search Results Modal */}
        <Modal
          open={openResultModal}
          onClose={handleGoBackToSearch}
          title="Search Results"
          customStyle={{
            marginTop: "30px",
            width: "98%",
            maxWidth: "100%",
            height: "90%",
            maxHeight: "100%",
            overflowY: "auto",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            position: "relative",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : searchData.length > 0 ? (
            <>
              {/* Header Row */}
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "10px",
                  fontWeight: 600,
                  fontSize: 13,
                  marginBottom: "10px",
                  paddingBottom: "10px",
                  borderBottom: "1px solid #eee",
                }}
              >
                {/* Left: Total + Filters */}
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    minWidth: 260,
                    gap: 10,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ flex: "0 0 auto" }}>
                    Total Members: {totalElements}
                  </div>
                  {appliedFilters.length > 0 && (
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={Styles.filterWrapper}>
                        <div style={Styles.filterContainer}>
                          {orderedFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                          {additionalFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Right: Reload + Back + Clear */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                    flex: "0 0 auto",
                  }}
                >
                  <div style={Styles.reload} onClick={onRefresh}>
                    <ReloadIcon />
                  </div>
                  <MuiButton
                    onClick={handleResetAndClose}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                      minWidth: "100px",
                    }}
                  >
                    Clear Filters
                  </MuiButton>
                  <MuiButton
                    onClick={handleGoBackToSearch}
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                    }}
                  >
                    Back
                  </MuiButton>
                </div>
              </div>

              {/* Table */}
              <div style={{ flex: 1, overflowX: "auto" }}>
                <AppointmentTrackingTable
                  searchData={searchData}
                  onSelectMemberForTransfer={onSelectMemberForTransfer}
                  onMemberSelect={onMemberSelect}
                  hasPermission={hasPermission}
                  showStatusColumn={isHelpDesk || isHelpDeskAdmin}
                  isChapterSi={isChapterSi}
                  isHelpDesk={isHelpDesk}
                  isAreaSi={isAreaSi}
                  isClusterSi={isClusterSi}
                  isZoneSi={isZoneSi}
                  isHelpDeskAdmin={isHelpDeskAdmin}
                  refreshList={onRefresh}
                />
              </div>

              {/* Pagination */}
              {searchData.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                  <Pagination
                    totalPages={totalPages}
                    totalResults={totalElements}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    onChange={onPaginationClick}
                    onPageSizeClick={onPageSizeClick}
                  />
                </div>
              )}
            </>
          ) : null}
        </Modal>

        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => setShowToast(null)}
        />
      </div>
    </>
  );
}

export default AppointmentTrackingList;
